@if (!isProd) {
  <fleetoperate-environment-ribbon
    position="bottom-left"
    [colour]="ribbonColour"
    [text]="ribbonText"
    [hoverText]="ribbonHoverText"
  ></fleetoperate-environment-ribbon>
}
@if (isLoading | async) {
  <mat-progress-bar
    mode="indeterminate"
    color="primary"
    style="position: fixed; top: 0; z-index: 100;"
    >
  </mat-progress-bar>
}
<router-outlet></router-outlet>
